import DraftedSalesOrders from "pages/dashboard/sales/all/DraftedSalesOrders";
import SalesOrders from "pages/dashboard/sales/all/SalesOrders";
import DraftOrders from "pages/dashboard/sales/draft/DraftOrders";
import Store from "pages/dashboard/sales/form/Store";

const SALES_ROUTES = [
  {
    path: "sales",
    children: [
      {
        path: "orders",
        element: <SalesOrders />,
      },
      {
        path: "orders/draft",
        element: <DraftedSalesOrders />,
      },
      {
        path: "orders/form",
        element: <Store key={"create"} />,
      },
      {
        path: "orders/form/:id",
        element: <Store key={"update"} />,
      },
      {
        path: "orders/outbox",
        element: <DraftOrders />,
      },
    ],
  },
];

export default SALES_ROUTES;
